import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content:center;align-items: center;
  flex-direction: column;
  padding: ${toRem(16)};
  height: calc(100dvh - ${toRem(100)});
  gap: ${toRem(24)};
`

export const TextContainer = styled.div`
  text-align: center;
  max-width: ${toRem(500)};
`

export const Title = styled.h1`
  font-weight: 700;
  font-size: ${toRem(24)};
  color: ${COLORS.FG.DEFAULT};
  line-height: ${32 / 24};
  &:not(:last-child) {margin-bottom: ${toRem(8)};}
`

export const Text = styled.p`
  color: ${COLORS.FG.SOFT};
  font-size: ${toRem(16)};
  line-height: ${20 / 16};
`